import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-card-body {
    padding: 0;
    padding-top: 9px;
  }
  ._38ARV > .ant-card-body {
    padding-top: 0px;
  }
  .editable {
    .rankmiTemplates-languageSelector {
      display: none;
    }
    > .ant-tabs + div {
      display: block;
      text-align: right;
      margin-top: -7px;
      button {
        border-radius: 8px;
        padding: 8px 12px;
        border: none;
        font-weight: bold;
        font-size: 14px;
        &:hover {
          opacity: 0.7;
        }
      }
      .rkm-btn-secondary {
        color: #4c4c4c;
        background-color: #f0f0f0;
      }
      .rkm-btn-success {
        float: left;
        margin-left: 0px;
        color: #0085ff;
        background-color: #e7f3fe;
        display: none;
      }
      .ant-btn-primary {
        color: white;
        background-color: #0085ff;
      }
    }
    > .ant-row {
      > .ant-col-12 {
        display: none;
      }
      > .ant-col-12 + .ant-col-12 {
        display: block;
      }
    }
  }

  #card {
    border-color: white;
    padding-right: 6px !important;
    padding-bottom: 0px !important;
    > .ant-btn {
      border: none;
      svg {
        top: 1px;
        left: -5px;
      }
    }
    > .ant-btn + p {
      position: relative;
      top: 2px;
    }
    > div > h1 {
      display: none;
    }
    > div > div > div > div > div > .ant-table-wrapper {
      margin-top: -4px;
      > div > div > div > div > div > table > tbody > tr > td > div > button {
        background-color: #f0f0f0 !important;
        border-radius: 8px;
        padding: 0 8px;
        border: none;
        box-shadow: none;
        &:hover {
          svg {
            opacity: 0.7;
          }
        }
        svg {
          margin-top: -5px;
          color: #4c4c4c;
        }
      }
    }
    > div > .rankmiTable-container {
      margin-top: -25px;
    }
    > div > div > h1 + button {
      float: right;
      top: 32px;
      z-index: 1;
      i {
        position: relative;
        top: -3px;
      }
    }
  }

  .tox-tinymce {
    border-radius: 16px;
    padding: 16px;
    border: 2px solid #dcdcdc;
    .tox-menubar > button > span {
      color: #757575;
    }
    .tox-toolbar__primary {
      border-top: none !important;
      background: unset;
      > div {
        border-right-color: #dcdcdc !important;
        border-bottom: 1px solid #dcdcdc;
      }
      .tox-tbtn > span {
        color: #808080;
        font-weight: bold;
      }
      .tox-tbtn > span > svg {
        fill: #808080;
        path {
          fill: #808080;
        }
      }
      .tox-tbtn--disabled > span > svg {
        fill: #aaa9a9;
        path {
          fill: #aaa9a9;
        }
      }
    }
    .tox-toolbar-overlord {
      background-color: white !important;
    }
  }

  .ant-tabs-top-bar {
    display: none;
  }

  .rankmiTemplates-templateHeaderNode + div {
    margin-top: -5px;
    margin-bottom: -18px;
  }
`

export const Preview = styled.div`
  float: left;
  margin-top: -40px;

  button {
    height: 40px;
    border-radius: 8px;
    padding: 8px 12px;
    border: none;
    font-weight: bold;
    font-size: 14px;
    color: #0085ff !important;
    background-color: #e7f3fe !important;
    z-index: 1;
    &:hover {
      opacity: 0.8;
    }
  }
`
